import { render, staticRenderFns } from "./RocketLink.vue?vue&type=template&id=0a852eae&"
import script from "./RocketLink.vue?vue&type=script&lang=js&"
export * from "./RocketLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports